import { render, staticRenderFns } from "./UsersCreatePersonalForm.vue?vue&type=template&id=0a96a358"
import script from "./UsersCreatePersonalForm.vue?vue&type=script&lang=js"
export * from "./UsersCreatePersonalForm.vue?vue&type=script&lang=js"
import style0 from "./UsersCreatePersonalForm.vue?vue&type=style&index=0&id=0a96a358&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports